<template>
    <b-button
        @click="$emit('click', $event)"
        class="rkm-navbar-nav-icon"
        pill
        title="Notificações"
    >
        <rkm-icon
            :icon="['far', 'bell']"
            class="mr-1"
        />

        <rkm-badge
            v-if="quantidadeNotificacoesNaoLidas > 0"
            color="danger"
        >
            {{quantidadeNotificacoesNaoLidas}}
        </rkm-badge>
    </b-button>
</template>

<script>
// Components.
import {BButton} from 'bootstrap-vue'

export default {
    components: {BButton},
    props: {
        quantidadeNotificacoesNaoLidas: {type: [Number, String], required: true},
    },
}
</script>

<style lang="scss" scoped>
$primary: #007bff;
.rkm-navbar-nav-icon {
    background-color: darken($primary, 10%) !important;
    border: none;
}
.rkm-navbar-nav-icon:hover {
    background-color: darken($primary, 15%) !important;
}
.rkm-navbar-nav-icon:active {
    background-color: darken($primary, 15%) !important;
    box-shadow: none !important;
}
.rkm-navbar-nav-icon:focus {
    background-color: darken($primary, 15%) !important;
    box-shadow: none !important;
}
</style>